
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import getFilters from "@/graphql/requests/getFilters"
import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import CreatorsView from "@/views/creators"
import useStaticProducts from "@/views/products/functions/useStaticProducts"

function CreatorsPage({ staticFilters }: { staticFilters: FilterGroup }) {
  const { filters } = useStaticProducts({ staticFilters, onlyCreators: true })

  if (!filters) return null

  return (
    <>
      <Head>
        <title>Wesprzyj Twórcę | fansi.pl</title>
        <SEO description="Najlepsi influencerzy i celebryci! Znajdziesz ich na Instagramie, TikToku i YouTube, ale to na fansi sprzedają swoje autorskie produkty." />
      </Head>
      <CreatorsView filters={filters} />
    </>
  )
}

CreatorsPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticFilters = await getFilters({ onlyCreators: true })
  return { props: { staticFilters }, revalidate: 1 }
}

export default CreatorsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/creators/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  